exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".E95Vu9vbZQQUQ6moOt5pe{font-size:17px;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir=ltr] .E95Vu9vbZQQUQ6moOt5pe{padding-right:10px}html[dir=rtl] .E95Vu9vbZQQUQ6moOt5pe{padding-left:10px}html[dir] ._350IUsc8pbUhLnCbFCtZSD{padding-top:1px}.sBb12KD5_jJWZn-_3aNi4{height:20px;font-size:12px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}html[dir] .sBb12KD5_jJWZn-_3aNi4{margin:12px 0}html[dir=ltr] ._1pBLpVQih8QQXxUIS9t4nN{padding-left:16px}html[dir=rtl] ._1pBLpVQih8QQXxUIS9t4nN{padding-right:16px}html[dir=ltr] ._1iu3DFggc9ED7j81ZzRy1j{padding-left:16px}html[dir=rtl] ._1iu3DFggc9ED7j81ZzRy1j{padding-right:16px}", ""]);

// exports
exports.locals = {
	"UnknownIcon": "E95Vu9vbZQQUQ6moOt5pe",
	"UnknownIconDiv": "_350IUsc8pbUhLnCbFCtZSD",
	"RibbonMessage": "sBb12KD5_jJWZn-_3aNi4",
	"YesLink": "_1pBLpVQih8QQXxUIS9t4nN",
	"NoLink": "_1iu3DFggc9ED7j81ZzRy1j"
};